import { Routes } from "@angular/router";

const scope: string = "feature/employee-routes";

export const EMPLOYEE_ROUTES: Routes = [
  {
    path: "new",
    data: {
      leaf: true,
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Mitarbeiter neu anlegen",
              token: "breadcrumb-label-create-new-employee",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: ":employeeNumber",
    data: {
      context: {
        breadcrumb: {
          apiPath: "api/customers/{customerNumber}/employees/{employeeNumber}"
        }
      }
    },
    children: [
      {
        path: "extended",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Erweiterte Daten",
                  token: "breadcrumb-label-extended-data",
                  scope
                }
              }
            }
          }
        }
      },
      {
        path: "extended-ch",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Erweiterte Daten CH",
                  token: "breadcrumb-label-extended-data-ch",
                  scope
                }
              }
            }
          }
        }
      },
      {
        path: "project-relation",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Projektzuordnung",
                  token: "breadcrumb-label-project-assignment",
                  scope
                }
              }
            }
          }
        }
      },
      {
        path: "admin",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Administration",
                  token: "breadcrumb-label-administration",
                  scope
                }
              }
            }
          }
        }
      }
    ]
  }
];
